import { Loading } from "components"
import { Fragment, PropsWithChildren } from "react"
import { DataList } from "../types"
import { Delete } from "./Delete"
import { LuFileSearch } from "react-icons/lu"
import moment from "moment"
import { useNavigate } from "react-router-dom"
import { StatusEnum } from ".."

type ProductImportLists = {
  data: DataList[]
  isLoading: boolean
  refetch: () => void
  currentPage: number
  limit: number
  size: number
  total: number
  modalConfig: { type: string, data: any, show: boolean }
  setModalConfig: (data: { type: string, data: any, show: boolean }) => void
}

export const ProductImportList = (params: PropsWithChildren<ProductImportLists>) => {
  const navigate = useNavigate()
  
  return (
    <Fragment>
      {params?.isLoading || params?.data?.length === 0 ? (
        <tr>
          <td colSpan={9} className="text-center">
            <Loading loading={params?.isLoading} errorText="No data available" />
          </td>
        </tr>
      ) : params?.data?.map((item, key) => (
          <tr key={key}>
            <td className="text-center">{key + 1}</td>
            <td>{moment(item?.transaction_date).format("DD/MM/YYYY")}</td>
            <td>{item?.file_name}</td>
            <td>{item?.file_description}</td>
            <td>{Number(item?.status) === StatusEnum.Review ? "Review" : "Submit"}</td>
            <td>
              <div className="flex items-center justify-center gap-3">
                {Number(item?.status) === StatusEnum.Review && <Delete data={item} refetch={params?.refetch} />}
                <LuFileSearch className="h-[20px] w-[20px] cursor-pointer" onClick={() => navigate("/setup/card/vendor-import/review/" + 1, { state: item })} />
              </div>
            </td>
          </tr>
      ))}
    </Fragment>
  )
}